// DESIGN.md v2 §5.3: the new shell is the default. The legacy shell stays reachable as a fallback.
//
// Off when any of these is true (checked once at load, so a change needs a reload):
//   - VITE_HOS_SHELL=false at build time,
//   - localStorage "xentros.hosShell" is "0" — set it with ?hosShell=0 in the address bar, back on with ?hosShell=1.

const STORAGE_KEY = "xentros.hosShell";

function readHosShellFlag(): boolean {
  if (import.meta.env.VITE_HOS_SHELL === "false") return false;
  if (typeof window === "undefined") return true;
  try {
    const param = new URLSearchParams(window.location.search).get("hosShell");
    if (param === "0") window.localStorage.setItem(STORAGE_KEY, "0");
    if (param === "1") window.localStorage.removeItem(STORAGE_KEY);
    return window.localStorage.getItem(STORAGE_KEY) !== "0";
  } catch {
    return true;
  }
}

export const HOS_SHELL_ENABLED = readHosShellFlag();
